import { defineComponent as _defineComponent } from 'vue'
import Icon from 'JS/components/Icon.vue';
import TransitionExpand from 'JS/components/transitions/TransitionExpand.vue';
import { ref } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'MobileFooterLinks',
  setup(__props) {


const expandedIndexes = ref<number[]>([]);

function handleExpandClick(index: number) {
	if (expandedIndexes.value.includes(index)) {
		expandedIndexes.value = expandedIndexes.value.filter(x => x !== index);
	} else {
		expandedIndexes.value.push(index);
	}
}

const linkTree: { parent: string, children: { name: string, link: string }[]}[] = [
	{
		parent: "Services",
		children: [
			{ name: "Automotive Service", link: "/automotive-service/" },
			{ name: "Drive Thru Pickup", link: "/store-pickup/" },
			{ name: "Same Day Local Delivery", link: "/same-day-local-delivery/" },
			{ name: "Pet & Animal Pharmacy", link: "/animalrx/" },
			{ name: "Registries & Lists", link: "/gift-registry/" },
			{ name: "FARMS Service", link: "/farms/" },
			{ name: "Gift Cards", link: "/gift-cards/" },
			{ name: "Extended Service Program", link: "/best-program/" },
			{ name: "Small Engine Repair", link: "/small-engine-repair-and-parts/" },
			{ name: "Hunting & Fishing Licenses", link: "/fishing-hunting-licenses/" },
			{ name: "Rebates", link: "/rebates/" },
			{ name: "VIP Pet Care", link: "https://www.farmandfleet.com/blog/vip-petcare-vaccinations-at-blains-farm-fleet/" },
			{ name: "Other Store Services", link: "/other-services/" },
		]
	},
	{
		parent: "Our Company",
		children: [
			{ name: "Mobile App", link: "/mobile-app/" },
			{ name: "About Us", link: "/about-us/" },
			{ name: "Real Estate", link: "/real-estate/" },
			{ name: "Careers at Blain's", link: "https://careers.farmandfleet.com/" },
		]
	},
	{
		parent: "Customer Care",
		children: [
			{ name: "FAQ", link: "/faq/" },
			{ name: "Best Price Promise", link: "/best-price-promise/" },
			{ name: "Tax Exemptions", link: "/account/certificate/" },
			{ name: "Coupons", link: "/coupons/" },
		]
	},
	{
		parent: "Blain's Mastercard",
		children: [
			{ name: "Pay and Manage Card", link: "https://www.card.fnbo.com/" },
			{ name: "Apply for the Card", link: "/mastercard/" },
		]
	},
];



return { __sfc: true,expandedIndexes, handleExpandClick, linkTree, Icon, TransitionExpand }
}

})